import React, { useState } from 'react'
import Wrapper from '../helpers/Wrapper'
import { useUser } from '../hooks/useUser'
import Input from '../components/Form Elements/Input'
import { useCart } from '../hooks/useCart'
import { displayImage } from '../helpers/config'
import FormatCurrency from '../helpers/FormatCurrency'
import Button from '../ui/Button'
import { Link, useNavigate } from 'react-router-dom'
import LoadingComponent from '../components/LoadingComponent'
import { LiaShippingFastSolid } from "react-icons/lia";
import { IoStorefrontOutline } from "react-icons/io5";
import RadioFull from '../ui/RadioFull'
import { useLocations } from '../hooks/useLocations'
import LocationRadio from '../ui/LocationRadio'
import AnimatePage from '../components/AnimatePage'
import { FaCcVisa } from 'react-icons/fa6'
import { BsCashStack } from 'react-icons/bs'
import { useMutation } from '@tanstack/react-query'
import { apiClient } from '../helpers/Axios'
import toast from 'react-hot-toast'
import { useShippingCosts } from '../hooks/useShippingCosts'
import { ChangePageTitle } from '../helpers/ChangeTitle'
import Select from '../components/Form Elements/Select'


function Checkout() {
    ChangePageTitle("Checkout")
    const [delivery, setDelivery] = useState('ship')
    const [paymentType, setPaymentType] = useState('paystack')
    const [pickup, setPickup] = useState(null)
    const [couponCode, setcouponCode] = useState('')
    const [coupon, setCoupon] = useState({ discount: 0 })
    const [shipping, setShipping] = useState({ cost: 0.00 })
    const [note, setNote] = useState('')


    const { data: pickup_locations } = useLocations()
    const { data: shippingCosts } = useShippingCosts()

    const [shippingData, setShippingData] = useState({
        country: "", firstname: "", lastname: "", address: "", appartment: "", city: "",
        postal_code: "", phone: ""
    })

    const handleShippingChange = (e) => {
        const { name, value } = e.target;
        setShippingData({ ...shippingData, [name]: value })
    }

    const navigate = useNavigate();
    const { data } = useUser()
    const { data: cart, isFetching } = useCart();


    if (!isFetching && !cart?.items?.length < 0) {
        navigate('/')
    }


    // Handle Apply Coupon

    const { mutate: apply, isPending: isCouponPending } = useMutation({
        mutationFn: (formData) => {
            return apiClient.post('/order/apply-coupon', formData)
        },
        onError: (error) => {
            toast.dismiss()
            toast.error(error?.response?.data || error?.message)
            setCoupon({ discount: 0 })
        },
        onSuccess: (data) => {
            toast.dismiss()
            toast.success("coupon applied")
            setCoupon(data.data)
        }
    })

    const applyCoupon = (e) => {
        e.preventDefault()
        apply({ code: couponCode })
    }


    // Send Order Handle

    const { mutate, isPending } = useMutation({
        mutationFn: (formData) => {
            return apiClient.post('/order/confirm-order', formData)
        },
        onError: (error) => {
            toast.dismiss()
            toast.error(error?.response?.data || error?.message)
        },
        onSuccess: (data) => {
            const res = data?.data;
            if (data.status === 200 && res) {
                if (res?.type === "paystack") {
                    window.location.href = res?.data?.authorization_url
                } else if (res?.type === "cod") {
                    window.location.href = "/success-order"
                }
            }
        }
    })

    const confirmOrder = (e) => {
        e.preventDefault()
        mutate({
            note,
            delivery_type: delivery, payment_type: paymentType, customer_email: data?.email, shipping_id: shipping?.id || "",
            shop_location_id: pickup, shipping_address: JSON.stringify(shippingData), coupon_id: coupon?.id || ""
        })
    }


    if (isFetching) {
        return <LoadingComponent />
    }

    return (
        <AnimatePage>

            {/* Log Errors */}
            {/* <div className="bg-red-50 p-4">
                {shippingError?.length > 0 && (
                    <div>
                        {shippingError?.map((err, i) => (
                            <p className="text-red-500">{err}</p>
                        ))}
                    </div>
                )}s
            </div>
 */}

            <div className='w-full relative my-7 mx-auto max-w-[1400px] h-full'>
                <Wrapper>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        {/* Delivery, Shipping, Payment Information */}
                        <div className="w-full bg-containerBg/50 p-5 rounded-2xl">
                            {/* Personal Details Contact */}
                            <div className='w-full py-5 border-b'>
                                <div className="space-y-0.5">
                                    <h3 className="font-serif text-gray-400">Account</h3>
                                    <p>{data?.email}</p>
                                </div>
                            </div>

                            {/* Delivery */}
                            <div className="w-full py-5 border-b">
                                <h2 className='font-serif text-xl font-medium sm:text-2xl'>Delivery</h2>

                                {/* Ship or  Pickup */}

                                <div className="mt-5 w-full">
                                    <RadioFull checked={delivery === 'ship'}
                                        id={"ship"} name="shipping" title={"Ship"}
                                        icon={<LiaShippingFastSolid />}
                                        onChange={() => setDelivery('ship')}
                                    />
                                    <RadioFull checked={delivery === 'pickup'}
                                        id={'pickup'} name="shipping" title={"Pickup in store"}
                                        icon={<IoStorefrontOutline />}
                                        onChange={() => {
                                            setDelivery('pickup')
                                            setShipping({ cost: 0 })
                                        }}
                                    />
                                </div>

                                {/* Contents */}
                                {delivery === 'ship' && (
                                    <div className="w-full space-y-3 mt-7">
                                        {/* Country */}
                                        <div className="w-full">
                                            <Select no_rounded onChange={handleShippingChange} name='country' value={shippingData?.country}>
                                                <option value="">Country / Region</option>
                                                <option value="ghana">Ghana</option>
                                            </Select>
                                        </div>

                                        {/* Firstname and Lastname */}
                                        <div className="w-full flex gap-2 items-center">
                                            <Input no_rounded placeholder="Firstname" value={shippingData?.firstname} name="firstname" onChange={handleShippingChange} />
                                            <Input no_rounded placeholder="Lastname" value={shippingData?.lastname} name="lastname" onChange={handleShippingChange} />
                                        </div>

                                        {/* Address */}
                                        <div className="w-full">
                                            <Input no_rounded placeholder="Address" value={shippingData?.address} name="address" onChange={handleShippingChange} />
                                        </div>

                                        {/* Apartment, suite, etc. (optional) */}
                                        <div className="w-full">
                                            <Input no_rounded placeholder="Apartment, suite, etc. (optional)" value={shippingData?.appartment} name="appartment" onChange={handleShippingChange} />
                                        </div>

                                        {/* Firstname and Lastname */}
                                        <div className="w-full flex gap-2 items-center">
                                            <Input no_rounded placeholder="City" value={shippingData?.city} name="city" onChange={handleShippingChange} />
                                            <Input no_rounded placeholder="Postal code (optional)" value={shippingData?.postal_code} name="postal_code" onChange={handleShippingChange} />
                                        </div>


                                        {/*Phone */}
                                        <div className="w-full">
                                            <Input no_rounded placeholder="Phone" value={shippingData?.phone} name="phone" onChange={handleShippingChange} />
                                        </div>
                                    </div>
                                )}

                                {delivery === 'pickup' && (
                                    <div className="mt-7">
                                        {pickup_locations && pickup_locations?.length > 0 ? (
                                            <div className="w-full">
                                                {pickup_locations?.map((location, i) => (
                                                    <LocationRadio
                                                        icon={<Direction to={location?.google_address_link} />}
                                                        id={location?.id} name="pickup" title={location?.name}
                                                        onChange={() => setPickup(location?.id)}
                                                    />
                                                ))}
                                            </div>
                                        ) :
                                            <div className='mt-7 text-gray-500'>
                                                <small>No Location Available Right Now</small>
                                            </div>
                                        }
                                    </div>
                                )}

                                {/* Shipping Method */}

                                {delivery === "ship" && (
                                    <div className="mt-7">
                                        <h2 className='font-serif text-xl font-medium'>Shipping Method</h2>

                                        {shippingCosts && shippingCosts?.length > 0 && (
                                            <div className="mt-5">
                                                {shippingCosts?.map((shipping, i) => (
                                                    <RadioFull
                                                        id={shipping?.id}
                                                        onChange={() => setShipping(shipping)}
                                                        name={"shipping-method"}
                                                        title={shipping?.area_name}
                                                        icon={<p className='font-medium text-sm'><FormatCurrency amount={shipping?.cost} /></p>}
                                                    />
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                )}


                                {/* PayInfo */}

                                <div className="mt-8">
                                    {/* Head */}
                                    <div className="">
                                        <h2 className='font-serif text-xl sm:text-2xl font-medium'>Payment</h2>
                                        <small className='text-gray-500'>All transactions are secure and encrypted.</small>

                                        <div className="mt-5">
                                            <RadioFull checked={paymentType === 'paystack'}
                                                id={"paystack"} name="payment_type" title={"Paystack"}
                                                icon={<FaCcVisa />}
                                                onChange={() => setPaymentType('paystack')}
                                            />
                                            <RadioFull checked={paymentType === 'cod'}
                                                id={"cod"} name="payment_type" title={"Cash On Delivery"}
                                                icon={<BsCashStack />}
                                                onChange={() => setPaymentType('cod')}
                                            />
                                        </div>
                                    </div>
                                </div>


                                {/* Deliverty Note */}
                                <div className="w-full mt-10">
                                    <h3 className="font-medium">Add Order Note</h3>
                                    <textarea
                                        placeholder='Add order note'
                                        value={note}
                                        onChange={(e) => setNote(e.target.value)}
                                        rows={6}
                                        className="w-full border rounded-2xl mt-5 
                                    outline-none p-3 text-sm focus:border-black"
                                    />
                                </div>
                            </div>
                        </div>




                        {/* Product and Others , final total */}
                        <div className="w-full h-screen sticky top-10 z-10">

                            {/* Coupon Change */}
                            <div className="w-full">
                                <h3 className="font-medium font-serif">Apply Coupon</h3>
                                <div className="mt-3 w-full flex flex-col sm:flex-row sm:items-center gap-4">
                                    <Input value={couponCode} onChange={(e) => setcouponCode(e.target.value)} placeholder="Coupon Code" />
                                    <Button onClick={applyCoupon} loading={isCouponPending}>Apply</Button>
                                </div>
                            </div>

                            {/* Products */}
                            {cart && (
                                <div className="w-full space-y-3 mt-8">
                                    {cart?.items?.map((product, i) => (
                                        <div key={i} className='flex items-center gap-4'>
                                            <div className="relative">
                                                <div className='size-20 overflow-hidden relative'>
                                                    <img
                                                        className='object-contain size-full'
                                                        src={displayImage(JSON.parse(product?.product?.images)[0])} alt=""
                                                    />
                                                </div>
                                                <p
                                                    className="absolute top-0 right-0 bg-[#666666] p-1
                                                text-white size-5 text-xs rounded-full flex items-center justify-center"
                                                >
                                                    {product?.quantity}
                                                </p>
                                            </div>

                                            {/* Details */}
                                            <div className="w-full font-serif">
                                                <h4 className="">{product?.product?.name}</h4>
                                                <p className="text-gray-500 text-sm">
                                                    {product?.variant?.size} {product?.variant?.color} {product?.variant?.material} {product?.variant?.type}
                                                </p>
                                                {product?.product?.customable && (
                                                    <p className="text-gray-500 text-xs flex gap-2">
                                                        Customization: <FormatCurrency amount={product?.customisation_price} />
                                                    </p>
                                                )}
                                            </div>

                                            {/* Price */}
                                            <p>
                                                <FormatCurrency amount={product?.price - product?.discount} />
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            )}


                            {/* Subtotal and other */}
                            <div className=" bg-containerBg p-5 mt-7 rounded-2xl space-y-3 font-serif sticky bottom-0">
                                {/* Subtotal */}
                                <div className="flex justify-between gap-2 items-center">
                                    <p className="text-gray-600 text-sm">Subtotal</p>
                                    <p className="text-gray-600 text-sm"><FormatCurrency amount={cart?.grand_total} /></p>
                                </div>
                                {/* Shipping */}
                                <div className="flex justify-between gap-2 items-center">
                                    <p className="text-gray-600 text-sm">Shipping</p>
                                    <p className="text-gray-600 text-sm"><FormatCurrency amount={shipping?.cost || 0} /></p>
                                </div>

                                {/* Discount */}
                                <div className="flex justify-between gap-2 items-center">
                                    <p className="text-gray-600 text-sm">Discount</p>
                                    <p className="text-gray-600 text-sm"><FormatCurrency amount={checkDiscount(coupon?.discount, cart?.grand_total)} /></p>
                                </div>

                                {/* Tptal */}
                                <div className="flex justify-between gap-2 items-center">
                                    <p className="font-medium text-xl">Total</p>
                                    <p className="font-medium text-xl">
                                        <FormatCurrency
                                            amount={(cart?.grand_total + shipping?.cost) - checkDiscount(coupon?.discount, cart?.grand_total)}
                                        />
                                    </p>
                                </div>

                                <div className='pt-3 w-full'>
                                    <Button loading={isPending} onClick={confirmOrder} fullWidth>Complete Order</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Wrapper >
            </div >
        </AnimatePage>
    )
}

export default Checkout


function Direction({ to }) {
    return (
        <Link
            target='_blank' to={to}
            className='bg-black py-1 px-4 text-sm rounded-full text-white'
        >
            Get Direction
        </Link>
    )
}

function checkDiscount(discount = 0, amount = 0) {
    const result = (discount / 100) * amount
    return result
}